var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["returns-restocking-icon.j2"] = require( "returns-restocking-icon.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/returns-restocking-messages.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
if(runtime.contextOrFrameLookup(context, frame, "feeCode")) {
output += "\n\n    ";
var t_1;
t_1 = env.getFilter("lower").call(context, (lineno = 2, colno = 27, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.currency"]))) + "" + "Short";
frame.set("currencyKey", t_1, true);
if(frame.topLevel) {
context.setVariable("currencyKey", t_1);
}
if(frame.topLevel) {
context.addExport("currencyKey", t_1);
}
output += "\n    ";
var t_2;
t_2 = (lineno = 3, colno = 30, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.featureConfigs.restockCodes." + "" + runtime.contextOrFrameLookup(context, frame, "feeCode") + "" + "." + "" + runtime.contextOrFrameLookup(context, frame, "currencyKey")]));
frame.set("restockMessage", t_2, true);
if(frame.topLevel) {
context.setVariable("restockMessage", t_2);
}
if(frame.topLevel) {
context.addExport("restockMessage", t_2);
}
output += "\n\n    ";
if(runtime.contextOrFrameLookup(context, frame, "restockMessage")) {
output += "\n\n        <div class=\"c-product-message__restocking c-product-message__restocking--outer\">\n            <a href=\"#\" class=\"c-product-message__restocking--inner js-returns-restocking-message\" ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "gaEvent"), env.opts.autoescape);
output += ">\n                ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "restockMessage"), env.opts.autoescape);
output += "\n                ";
env.getTemplate("returns-restocking-icon.j2", false, "product/templates/returns-restocking-messages.j2", null, function(t_5,t_3) {
if(t_5) { cb(t_5); return; }
t_3.render(context.getVariables(), frame, function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
output += t_4
output += "\n            </a>\n        </div>\n\n    ";
})});
}
output += "\n\n";
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/returns-restocking-messages.j2"] , dependencies)